module.exports = require("@material-ui/icons/KeyboardArrowRight");